import * as React from 'react';

const SvgExpert = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.482 9.5a1.018 1.018 0 1 0 2.036 0 1.018 1.018 0 0 0-2.036 0Zm4.241 0a1.018 1.018 0 1 0 2.036 0 1.018 1.018 0 0 0-2.036 0Zm-8.482 0a1.018 1.018 0 1 0 2.036 0 1.018 1.018 0 0 0-2.036 0Zm14.021-3.681a9.504 9.504 0 0 0-5.08-5.081A9.455 9.455 0 0 0 9.5 0h-.042A9.478 9.478 0 0 0 0 9.545a9.53 9.53 0 0 0 1.018 4.239v3.223a.975.975 0 0 0 .975.975H5.22A9.53 9.53 0 0 0 9.458 19h.044c1.27 0 2.502-.246 3.662-.727a9.424 9.424 0 0 0 3.028-2.02A9.475 9.475 0 0 0 19 9.543a9.463 9.463 0 0 0-.738-3.723Zm-3.204 9.288A7.847 7.847 0 0 1 9.5 17.388h-.036a7.918 7.918 0 0 1-3.67-.922l-.179-.096H2.63v-2.985l-.096-.178a7.917 7.917 0 0 1-.922-3.671 7.84 7.84 0 0 1 2.281-5.594 7.829 7.829 0 0 1 5.573-2.33h.036a7.85 7.85 0 0 1 5.582 2.309 7.857 7.857 0 0 1 2.31 5.615 7.858 7.858 0 0 1-2.336 5.57Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgExpert;
